import { render, staticRenderFns } from "./batchServiceAdminDispatch.vue?vue&type=template&id=de322a12&scoped=true&"
import script from "./batchServiceAdminDispatch.vue?vue&type=script&lang=js&"
export * from "./batchServiceAdminDispatch.vue?vue&type=script&lang=js&"
import style0 from "./batchServiceAdminDispatch.vue?vue&type=style&index=0&id=de322a12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de322a12",
  null
  
)

export default component.exports